import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BottomSheetComponent } from './bottom-sheet.component';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { NFCFacade } from '@app/pages/nfc/state/facades/nfc.facade';
import { BarcodeScanningModalComponent } from '../barcode-scanning-modal.component';

@NgModule({
  declarations: [BottomSheetComponent, BarcodeScanningModalComponent],
  imports: [
    TranslateModule,
    FormsModule,
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    QRCodeModule
  ],
  exports: [BottomSheetComponent],
  providers: [NFCFacade],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BottomSheetModule { }
